import { useMutation, useQuery } from "react-query";
import { normalFetch } from "../../fetch-api/get";
import { putApi } from "../../fetch-api/put";


const REWARD_KEYS = {
    GET_REWARD_CONFIG: 'get-reward-config',
    SET_REWARD_CONFIG: 'set-reward-config'
}


const useGetRewardConfig = () => {

    return useQuery(
        REWARD_KEYS.GET_REWARD_CONFIG, () => normalFetch('settings/reward'),
        {
            select: res => res?.data?.data
        }
    )
}


const useSetRewardConfig = () => {

    return useMutation(
        REWARD_KEYS.SET_REWARD_CONFIG, (data) => putApi(data, 'settings/reward')
    )
}


export {
    useSetRewardConfig,
    useGetRewardConfig,
}
